import ContactModule from "../modules/contact/ContactModule";

const ContactPage = () => {
  return <ContactModule />;
};

export default ContactPage;
